import React, {ReactNode} from "react";
import {Route, Routes} from "react-router-dom";
import {HomePage} from "./home/HomePage";
import {LoginPage} from "./login/LoginPage";
import {LogoutPage} from "./logout/LogoutPage";
import {NotFoundPage} from "./notfound/NotFoundPage";
import {OrdersOverviewPage} from "./orders/OrdersOverviewPage";
import {OrderPackagePage} from "./orders/orderPackageComponets/OrderPackagePage";
import {UpdateUnderwritingResultPage} from "./orders/UpdateUnderwritingResultPage";
import {MailexHomePage} from "./mailex/MailexHomePage";
import {UserSettingsPage} from "./settings/UserSettingsPage";
import {DynamicFormsOverviewPage} from "./dynamicforms/DynamicFormsOverviewPage";
import {generalError} from "./fragments/ErrorElement";
import {ErrorBoundary} from "react-error-boundary";
import {DynamicFormsQuestionDetailsPage} from "./dynamicforms/questions/DynamicFormsQuestionDetails";
import {DynamicFormsQuestionsOverviewPage} from "./dynamicforms/questions/DynamicFormsQuestionsOverview";
import {DynamicFormsFormDetailsPage} from "./dynamicforms/forms/DynamicFormsFormDetails";
import {DynamicFormsFormsOverviewPage} from "./dynamicforms/forms/DynamicFormsFormsOverview";
import {DynamicFormsChangesOverviewPage} from "./dynamicforms/changes/DynamicFormsChangesOverview";
import {ProductsChangesOverview} from "./products/ProductsChangesOverview";
import {SuppliersOverview} from "./products/suppliers/SuppliersOverview";
import {SuppliersDetails} from "./products/suppliers/SuppliersDetails";
import {ProductsDetails} from "./products/products-details/ProductsDetails";
import {ProductsOverview} from "./products/products-details/ProductsOverview";
import {ComparatorConfigsOverview} from "./products/comparator-configs/ComparatorConfigsOverview";
import {ComparatorConfigsDetails} from "./products/comparator-configs/ComparatorConfigsDetails";
import {IncentiveOverview} from "./products/products-Incentive/IncentiveOverview";
import {IncentiveDetails} from "./products/products-Incentive/IncentiveDetails";
import {QueryToolHomePage} from "./querytool";
import {Jobs} from "./querytool/components/job/Jobs";
import {JobRuns} from "./querytool/components/job-run/JobRuns";
import {JobStepRuns} from "./querytool/components/job-run/JobStepRuns";
import {JobForm} from "./querytool/components/job/JobForm";
import {JobDefinitions} from "./querytool/components/job-definition/JobDefinitions";
import {AllJobRuns} from "./querytool/components/job-run/AllJobRuns";
import {JobDefinitionFormWrapper} from "./querytool/components/job-definition/JobDefinitionFormWrapper";
import {TranslationItemDetails} from "./translations/TranslationItemDetails";
import {TranslationItemOverview} from "./translations/TranslationItemOverview";
import {PhraseItemDetails} from "./translations/PhraseItemDetails";
import {PhraseItemsOverview} from "./translations/PhraseItemsOverview";
import {ModuleDetails} from "./translations/ModuleDetails";
import {ModulesOverview} from "./translations/ModulesOverview";
import {TranslationsChangesOverview} from "./translations/TranslationsChangesOverview";
import {NewRunFromExistingForm} from "./querytool/components/job-run/NewRunFromExistingForm";
import {MonitoringOverviewPage} from "./monitoring/MonitoringOverviewPage";
import {ComparisonInsightsPage} from "./monitoring/comparisons/ComparisonInsightsPage";
import {TranslationsOverview} from "./translations/TranslationsOverview";
import {ReportModuleOverview} from "./reports/ReportModuleOverview";
import {ProductsCommissionSetupReport} from "./reports/ProductsCommissionSetupReport";
import {Documents} from "./documents/components/documents/Documents";
import {Document} from "./documents/components/document/Document";
import {ViewDocument} from "./documents/components/viewdocument/ViewDocument";
import {AdminSettingsPage} from "./documents/admin/AdminSettingsPage";
import {AdminSetsPage} from "./documents/admin/AdminSetsPage";
import {AdminLookupsPage} from "./documents/admin/AdminLookupsPage";
import {PartnerHierarchyOverview} from "./products/partner-hierarchy/PartnerHierarchyOverview";
import {PartnerHierarchyDetails} from "./products/partner-hierarchy/PartnerHierarchyDetails";
import {PoliciesOverviewPage} from "./authorization/policies/PoliciesOverviewPage";
import {PolicyDetailsPage} from "./authorization/policies/PolicyDetailsPage";
import {PolicyUsagesOverviewPage} from "./authorization/policyusages/PolicyUsagesOverviewPage";
import {AuthorizationOverviewPage} from "./authorization/AuthorizationOverviewPage";
import {AuthorizationDeployPage} from "./authorization/deploy/AuthorizationDeployPage";
import {TranslationApprovalQueue} from "./translations/TranslationApprovalQueue";
import {LogFile} from "./querytool/components/job-run/LogFile";
import {CustomAttributeSetupDetails} from "./products/custom-attribute-setup/CustomAttributeSetupDetails";
import {CustomAttributeSetupOverview} from "./products/custom-attribute-setup/CustomAttributesSetupOverview";
import {CustomAttributeBulkEditorProductsWizard} from "./products/bulk-views/custom-attribute-bulk-editor-products/CustomAttributeBulkEditorProductsWizard";
import {CustomAttributeBulkEditorSuppliersWizard} from "./products/bulk-views/custom-attribute-bulk-editor-suppliers/CustomAttributeBulkEditorSuppliersWizard";
import {IncentiveRegisterReport} from "./reports/IncentiveRegisteReport";
import {CustomOrdersReport} from "./reports/CustomOrdersReport";
import {EnergyAuctionReport} from "./reports/EnergyAuctionReport";
import {ComparatorIntakesReport} from "./reports/ComparatorIntakesReport";

export function RouterItems() {
	return (
		<div
			style={{
				padding: "10px",
				display: "flex",
				flexDirection: "column",
				flexGrow: 1.0,
				height: "100%",
			}}
		>
			<Routes>
				<Route index element={<Page child={<HomePage />} />} />
				<Route path={"login"} element={<Page child={<LoginPage />} />} />
				<Route path={"logout"} element={<Page child={<LogoutPage />} />} />
				<Route path={"authorization"}>
					<Route index element={<Page child={<AuthorizationOverviewPage />} />}/>
					<Route path={"policies"}>
						<Route index element={<Page child={<PoliciesOverviewPage />} />}/>
						<Route path={":id"} element={<Page child={<PolicyDetailsPage />} />}/>
					</Route>
					<Route path={"policyusages"}>
						<Route index element={<Page child={<PolicyUsagesOverviewPage />} />}/>
					</Route>
					<Route path={"deploy"}>
						<Route index element={<Page child={<AuthorizationDeployPage />} />}/>
					</Route>
				</Route>
				<Route path={"messaging"}>
					<Route path={"email"} element={<Page child={<MailexHomePage />} />} />
				</Route>
				<Route
					path={"settings"}
					element={<Page child={<UserSettingsPage />} />}
				/>
				<Route path={"orders"}>
					<Route index element={<Page child={<OrdersOverviewPage />} />} />
					<Route path={"update-underwriting-result"} element={<Page child={<UpdateUnderwritingResultPage />} />} />
					<Route path={":id"} element={<Page child={<OrderPackagePage />} />} />
				</Route>
				<Route path={"dynamicforms"}>
					<Route
						index
						element={<Page child={<DynamicFormsOverviewPage />} />}
					/>
					<Route
						path={"deploy"}
						element={<Page child={<DynamicFormsChangesOverviewPage />} />}
					/>
					<Route path={"forms"}>
						<Route
							index
							element={<Page child={<DynamicFormsFormsOverviewPage />} />}
						/>
						<Route
							path={":id"}
							element={<Page child={<DynamicFormsFormDetailsPage />} />}
						/>
					</Route>
					<Route path={"questions"}>
						<Route
							index
							element={<Page child={<DynamicFormsQuestionsOverviewPage />} />}
						/>
						<Route
							path={":id"}
							element={<Page child={<DynamicFormsQuestionDetailsPage />} />}
						/>
					</Route>
				</Route>
				<Route path={"querytool"}>
					<Route
						index={true}
						element={<Page child={<QueryToolHomePage />} />}
					/>
					<Route path={"jobdefinitions"}>
						<Route index={true} element={<Page child={<JobDefinitions />} />} />
						<Route path={"modify"} element={<Page child={<JobDefinitionFormWrapper />} />} />
					</Route>
					<Route path={"job-runs"}>
						<Route index={true} element={<Page child={<AllJobRuns />} />} />
					</Route>
					<Route path={"jobs"}>
						<Route index={true} element={<Page child={<Jobs />} />} />
						<Route path={"modify"} element={<Page child={<JobForm />} />} />
						<Route path={"runs"} element={<Page child={<JobRuns />} />} />
						<Route path={"runs"}>
							<Route path={"newrunfromrun"} element={<Page child={<NewRunFromExistingForm />} />} />
							<Route path={"steps"} element={<Page child={<JobStepRuns />} />}/>
							<Route path={"steps"}>
								<Route path={"logfile"} element={<Page child={<LogFile />} />}/>
							</Route>
						</Route>
					</Route>
				</Route>
				<Route path={"documents"}>
					<Route index element={<Page child={<Documents />} />} />
					<Route
						path={":documentId"}
						element={<Page child={<Document />} />}
					/>
					<Route path={"viewDocument"}>
						<Route
							path={":documentIdentifier"}
							element={<Page child={<ViewDocument />} />}
						/>
					</Route>
					<Route path={"admin"}>
						<Route path={"settings"} element={<Page child={<AdminSettingsPage />} />} />
						<Route path={"sets"} element={<Page child={<AdminSetsPage />} />} />
						<Route path={"lookups"} element={<Page child={<AdminLookupsPage />} />} />
					</Route>
				</Route>
				<Route path={"products"}>
					<Route index element={<Page child={<ProductsOverview />} />} />
					<Route
						path={"deploy"}
						element={<Page child={<ProductsChangesOverview />} />}
					/>
					<Route path={"suppliers"}>
						<Route
							index
							element={<Page child={<SuppliersOverview />} />}
						/>
						<Route path={":supplierId"}>
							<Route
								index
								element={<Page child={<SuppliersDetails />} />}
							/>
							<Route path={":tab"}>
								<Route
									index
									element={<Page child={<SuppliersDetails />} />}
								/>
							</Route>
						</Route>
					</Route>
					<Route path={"products"}>
						<Route
							index
							element={<Page child={<ProductsOverview />} />}
						/>
						<Route path={":productId"}>
							<Route
								index
								element={<Page child={<ProductsDetails />} />}
							/>
							<Route path={":tab"}>
								<Route
									index
									element={<Page child={<ProductsDetails />} />}
								/>
							</Route>
						</Route>
					</Route>
					<Route path={"comparatorconfigs"}>
						<Route
							index
							element={<Page child={<ComparatorConfigsOverview />} />}
						/>
						<Route path=":configId">
							<Route
								index
								element={<Page child={<ComparatorConfigsDetails />} />}
							/>
						</Route>
					</Route>
					<Route path={"incentives"}>
						<Route
							index
							element={<Page child={<IncentiveOverview />} />}
						/>
						<Route path=":incentiveId">
							<Route
								index
								element={<Page child={<IncentiveDetails />} />}
							/>
						</Route>
					</Route>
					<Route path={"partnerhierarchy"}>
						<Route
							index
							element={<Page child={<PartnerHierarchyOverview />} />}
						/>
						<Route path=":id">
							<Route
								index
								element={<Page child={<PartnerHierarchyDetails />} />}
							/>
						</Route>
					</Route>
					<Route path={"custom_attribute_setup"}>
						<Route
							index
							element={<Page child={<CustomAttributeSetupOverview />} />}
						/>
						<Route path=":id">
							<Route
								index
								element={<Page child={<CustomAttributeSetupDetails />} />}
							/>
						</Route>
					</Route>
					<Route path={"custom_attribute_bulk_products"}>
						<Route
							index
							element={<Page child={<CustomAttributeBulkEditorProductsWizard />} />}
						/>
					</Route>
					<Route path={"custom_attribute_bulk_suppliers"}>
						<Route
							index
							element={<Page child={<CustomAttributeBulkEditorSuppliersWizard />} />}
						/>
					</Route>
					
				</Route>
				<Route path={"translations_setup"}>
					<Route index element={<Page child={<TranslationsOverview/>}/>}/>
					<Route path={"deploy"} element={<Page child={<TranslationsChangesOverview/>}/>}/>
					<Route path={"modules"}>
						<Route index element={<Page child={<ModulesOverview/>}/>}/>
						<Route path={":id"}>
							<Route index element={<Page child={<ModuleDetails/>}/>}/>
						</Route>
					</Route>
					<Route path={"phrases"}>
						<Route index element={<Page child={<PhraseItemsOverview/>}/>}/>
						<Route path={":id"}>
							<Route index element={<Page child={<PhraseItemDetails/>}/>}/>
						</Route>
					</Route>
					<Route path={"translations"}>
						<Route index element={<Page child={<TranslationItemOverview/>}/>}/>
						<Route path={":id"}>
							<Route index element={<Page child={<TranslationItemDetails/>}/>}/>
						</Route>
					</Route>
					<Route path={"approval-queue"}>
						<Route index element={<Page child={<TranslationApprovalQueue/>}/>}/>
					</Route>
				</Route>
				<Route path={"monitoring"}>
					<Route
						index
						element={<Page child={<MonitoringOverviewPage />} />}
					/>
					<Route
						path={"comparisons"}
						element={<Page child={<ComparisonInsightsPage />} />}
					/>
				</Route>
				<Route path={"Reports"}>
					<Route
						index
						element={<Page child={<ReportModuleOverview />} />}
					/>
					<Route
						path={"products_incentive_setup_report"}
						element={<Page child={<ProductsCommissionSetupReport />} />}
					/>
					<Route
						path={"incentive_register_report"}
						element={<Page child={<IncentiveRegisterReport />} />}
					/>
					<Route
						path={"custom_orders_report"}
						element={<Page child={<CustomOrdersReport />} />}
					/>
					<Route
						path={"energy_auction_report"}
						element={<Page child={<EnergyAuctionReport />} />}
					/>
					<Route
						path={"comparator_intakes_report"}
						element={<Page child={<ComparatorIntakesReport />} />}
					/>
				</Route>
				<Route path={"*"} element={<Page child={<NotFoundPage/>}/>}/>
			</Routes>
		</div>
	);
}

interface PageProps {
	child: ReactNode;
}

function Page(props: PageProps) {
	return (
		<ErrorBoundary FallbackComponent={generalError}>
			{props.child}
		</ErrorBoundary>
	);
}
